import dayjs, { Dayjs } from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import duration from 'dayjs/plugin/duration';
import ja from 'dayjs/locale/ja';

// localeの読み込み
dayjs.locale(ja);

dayjs.extend(isSameOrAfter);
dayjs.extend(duration);

export type DateType = Dayjs;

/**
 * 年月日でフォーマットし返却する
 * APIへのリクエストパラメータ作成用の関数
 * ※引数がnullの場合は本日の年月日を返却する
 */
export const formatDate = (date: Dayjs | null) => {
	if (!date) {
		return dayjs().format('YYYY/MM/DD');
	}

	return date.format('YYYY/MM/DD');
};

/**
 * 現在日時をフォーマットし返却する
 * UI上の更新日時を表示する用の関数
 */
export const formatNowDatetime = () => {
	return dayjs().format('YYYY/MM/DD HH:mm:ss');
};

/**
 * 現在日時をフォーマットせずにオブジェクトのまま返却する
 */
export const objectNowDate = () => {
	return dayjs();
};

/**
 * 昨日の日時をフォーマットせずにオブジェクトのまま返却する
 */
export const objectYesterdayDate = () => {
	return dayjs().subtract(1, 'd');
};

/**
 * 開始日と終了日を比較し有効な期間が設定されているかを判定する
 */
export const validateSearchPeriod = (startDate: Dayjs | null, endDate: Dayjs | null) => {
	if (!startDate || !endDate) {
		return false;
	}

	const startDay = startDate.startOf('day');
	const endDay = endDate.startOf('day');

	const isInRange = endDay.diff(startDay, 'day') <= 6; // 検索期間が7日以内（7日も含む）かのチェック（暫定）
	const isSameOrAfter = endDay.isSameOrAfter(startDay); // 終了日が開始日と同じ or 開始日より後かのチェック
	const isSameOrPast = dayjs().isSameOrAfter(endDay); // 終了日が未来になっていないかのチェック

	if (!isInRange || !isSameOrAfter || !isSameOrPast) {
		return false;
	}

	return true;
};

/**
 * 検索日に有効な日付が設定されているかを判定する
 */
export const validateSearchDate = (searchDate: Dayjs | null) => {
	if (!searchDate) {
		return false;
	}

	const searchDay = searchDate.startOf('day');
	const isSameOrPast = dayjs().isSameOrAfter(searchDay);

	if (!isSameOrPast) {
		return false;
	}

	return true;
}

/**
 * 現在日時との差分をミリ秒で返却する
 */
export const diffMilisecondsFromNowDatetime = (targetDatetime: string) => {
	return dayjs().diff(dayjs(targetDatetime));
};

/**
 * 時をミリ秒に変換する
 */
export const convertHoursIntoMiliseconds = (hours: number) => {
	return dayjs.duration({ hours: hours }).asMilliseconds();
};
